import { StateCreator } from "zustand";
import { AppNotification } from "../../../types/shared";
import { v4 } from "uuid";

export interface NotificationsSlice {
  notifications?: AppNotification[];
  showNotification: (notification: AppNotification) => void;
  hideNotification: (id: string) => void;
  clearNotifications: () => void;
}

export const createNotificationsSlice: StateCreator<NotificationsSlice> = (
  set,
  get
) => ({
  notifications: [],
  showNotification: (notification: AppNotification) => {
    notification = { id: v4(), ...notification };
    set({ notifications: get()?.notifications?.concat(notification) });
    setTimeout(() => get()?.hideNotification(notification?.id), 4500);
  },
  clearNotifications: () => set({ notifications: [] }),
  hideNotification: (id: string) =>
    set({ notifications: get()?.notifications?.filter((n) => n?.id !== id) }),
});
